module.exports = __webpack_public_path__ + "media/vlads3.4f8ee4ba.webm";